const getters = {
  accountId: state => state.user.accountId,
  nickname: state => state.user.nickname,
  }
  export default getters
  


// WEBPACK FOOTER //
// ./src/store/getters.js